/**
 * Product Sales Report Data Mapper
 *
 * Data transformation between DTOs and domain models
 */

import {
  ProductSalesSummary,
  ProductSalesReportSummary,
  ProductSalesReportData
} from '../models/productSalesReport.model';
import {
  ProductSalesSummaryDTO,
  ProductSalesReportSummaryDTO,
  ProductSalesReportDataDTO
} from '../models/productSalesReport.dto';

export const productSalesReportMapper = {
  toProductSalesSummary(dto: ProductSalesSummaryDTO): ProductSalesSummary {
    return {
      product_id: dto.product_id,
      product_name: dto.product_name || 'غير محدد',
      product_barcode: dto.product_barcode ?? undefined,
      product_brand: dto.product_brand ?? undefined,
      product_category: dto.product_category ?? undefined,
      quantity_sold: dto.quantity_sold || 0,
      unit_price: dto.unit_price || 0,
      total_revenue: dto.total_revenue || 0,
      stores_count: dto.stores_count,
      orders_count: dto.orders_count
    };
  },

  toProductSalesReportSummary(dto: ProductSalesReportSummaryDTO): ProductSalesReportSummary {
    return {
      total_products: dto.total_products || 0,
      total_quantity_sold: dto.total_quantity_sold || 0,
      total_revenue: dto.total_revenue || 0,
      average_unit_price: dto.average_unit_price || 0
    };
  },

  toProductSalesReportData(dto: ProductSalesReportDataDTO): ProductSalesReportData {
    return {
      product_sales: dto.product_sales.map(item => 
        productSalesReportMapper.toProductSalesSummary(item)
      ),
      summary: productSalesReportMapper.toProductSalesReportSummary(dto.summary),
      filters: dto.filters
    };
  }
};

